import { z } from "zod";
import { isValidPhoneNumber } from "libphonenumber-js";

export const modifyReleaseStrategySchema = z.object({
    name: z.string().nonempty(),
    phone: z.string().nonempty().refine(isValidPhoneNumber),
    email: z.email(),
});

export type ModifyReleaseStrategyDTO = z.infer<typeof modifyReleaseStrategySchema>;
